import type App from '@/App.vue'
import { BenQuery } from './BenQuery'
import { BenFn } from '@/common/BenFn'

export class BenForm {
  static init(dones, app: InstanceType<typeof App>) {
    const $divList = BenQuery.query('.c-form')
    $divList.forEach(($div: any) => {
      if (dones.includes($div)) return
      dones.push($div)
      _init($div, app)
    })
  }
}

async function _init($div: any, app: InstanceType<typeof App>) {
  await BenQuery.nextTick()
  const $form = $div.querySelector(':scope > form')
  const $success = $div.querySelector(':scope > .success')
  let timer = null as any
  const content = BenQuery.getData('formContent')
  const $btn = $form.querySelector('.form-submit-btn') as HTMLElement
  $form.content.value = content || ''
  $btn.addEventListener('click', async (e) => {
    e.preventDefault()
    const subject = $form.subject?.value.trim()
    const name = $form.name?.value.trim()
    const email = $form.email?.value.trim()
    const tel = $form.tel?.value.trim()
    const content = $form.content?.value.trim()
    if (!email && !tel) {
      const $tip = $form.querySelector('.tip')
      $tip.classList.add('show')
      clearTimeout(timer)
      timer = setTimeout(() => {
        $tip.classList.remove('show')
      }, 3000)
      return
    }
    $btn.classList.add('disabled')
    const str1 = `Subject: ${subject}\n`
    const str2 = `Name: ${name}\n`
    const str3 = `Email: ${email}\n`
    const str4 = `Tel: ${tel}\n`
    const str5 = `Content: ${content}\n`
    const params = ['---Inquery---\n\n' + str1 + str2 + str3 + str4 + str5, { showWin: false }] as Parameters<typeof app.sendMessage>
    let rs = await app.sendMessage(...params)
    if (!rs) {
      await BenFn.sleep(3000)
      rs = await app.sendMessage(...params)
    }
    if (!rs) {
      await BenFn.sleep(3000)
      rs = await app.sendMessage(...params)
    }
    $form.remove()
    $success.classList.add('show')
  })
}
